module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAV1BMVEUAAADNzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc2f2VuHAAAAHHRSTlMA/BHx0e53NxoE9Ovm38O1fU8+x7KZb2xfSDAlkZXdnAAAAGtJREFUGNNNzVkWgCAIQFFEs3myudj/OpMOJu/PewQArt4hqGZDNGroKXYqMAxdncER92SY+D1ADm2EDVR7BBMU1EOU4lZSdSwl4IwipeWp1VJziARL0ojyp03i0p5FoP1v+eYDr45NzhQeXnWKCUQJcr1qAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/dh1.png
// module id = wLjF
// module chunks = 15